import React from 'react';
import { Quote, Mail, ArrowRight } from 'lucide-react';

// Import Swiper React components and modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

export default function TestimonialsAndCTA() {
  const testimonials = [
    {
      quote:
        'Inimai Solutions delivered a robust AI solution that streamlined our operations and improved decision-making across the organization.',
      name: 'Ramesh Kumar',
      role: 'CTO, FinServe Solutions',
      avatar:
        'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
    },
    {
      quote:
        'Their team understood our challenges and provided innovative solutions that exceeded our expectations. Highly professional and reliable!',
      name: 'Priya Natarajan',
      role: 'Head of Technology, MedCare Hospitals',
      avatar:
        'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&auto=format&fit=crop&q=80',
    },
    {
      quote:
        'Excellent support and seamless implementation. Inimai Solutions is our trusted technology partner for growth.',
      name: 'Arun Prakash',
      role: 'Operations Director, RetailMax',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80',
    },
    {
      quote:
        'The team demonstrated outstanding expertise and responsiveness. They transformed our customer experience completely.',
      name: 'Deepa Subramanian',
      role: 'VP of Engineering, CloudScale',
      avatar:
        'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80',
    },
  ];

  return (
    <section className="w-full bg-[#f8f9fa] pt-12 pb-0 font-sans text-gray-800">
      
      {/* --- TESTIMONIALS SECTION --- */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        
        {/* Section Header */}
        <div className="text-center mb-8">
          <p className="text-xs font-bold tracking-widest text-[#f25c05] uppercase">
            WHAT OUR CLIENTS SAY
          </p>
        </div>

        {/* Swiper Carousel */}
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            el: '.custom-swiper-pagination',
          }}
          breakpoints={{
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="w-full pb-2"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index} className="h-auto flex">
              <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col justify-between hover:shadow-md transition-shadow duration-200 w-full">
                
                {/* Top Quote Icon & Text */}
                <div>
                  <Quote className="w-5 h-5 text-[#f25c05] fill-[#f25c05] mb-3 rotate-180" />
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-normal">
                    {item.quote}
                  </p>
                </div>

                {/* Author Details */}
                <div className="flex items-center space-x-3 mt-6 pt-2 border-t border-gray-50">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover border border-gray-100"
                  />
                  <div className="flex flex-col">
                    <span className="text-xs font-bold text-gray-900">
                      {item.name}
                    </span>
                    <span className="text-[11px] text-gray-500 font-medium">
                      {item.role}
                    </span>
                  </div>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Pagination Container */}
        <div className="custom-swiper-pagination flex items-center justify-center space-x-2 mt-8" />

      </div>

      {/* --- CALL TO ACTION (CTA) BANNER --- */}
      <div className="w-full bg-[#f25c05] py-5 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          
          {/* Left Text & Icon */}
          <div className="flex items-center space-x-4 text-white">
            <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm flex-shrink-0">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-bold leading-snug">
                Ready to Transform Your Business?
              </h3>
              <p className="text-xs text-white/90 font-normal">
                Let's build intelligent solutions together.
              </p>
            </div>
          </div>

          {/* Right Button */}
          <a
            href="#contact"
            className="inline-flex items-center space-x-2 bg-[#111111] hover:bg-black text-white font-semibold text-xs px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 group flex-shrink-0"
          >
            <span>Get In Touch</span>
            <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
          </a>

        </div>
      </div>

      {/* Custom Styling for Swiper Pagination Bullets */}
      <style>{`
        .custom-swiper-pagination .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background-color: #d1d5db;
          opacity: 1;
          border-radius: 9999px;
          transition: all 0.3s ease;
          margin: 0 4px !important;
        }
        .custom-swiper-pagination .swiper-pagination-bullet-active {
          width: 24px;
          background-color: #f25c05;
        }
      `}</style>

    </section>
  );
}